const PlanCategoryList = [
  {
    planName: 'MAHABAHUBALI PLAN',
    categories: {
      item_category: 'NSE Cash',
      item_category2: 'NSE F&O',
      item_category3: 'MCX',
      item_category4: 'Currency',
    },
  },
  {
    planName: 'BRAHMASTRA PLAN',
    categories: {
      item_category: 'NSE Cash',
      item_category2: 'NSE F&O',
      item_category3: 'MCX',
      item_category4: 'Currency',
    },
  },
  {
    planName: 'COMBO OF EVERYTHING (COE)',
    categories: {
      item_category: 'Mahabahubali plan',
      item_category2: 'Brahmastra plan',
      item_category3: 'Stock of the Month',
      item_category4: 'BTST & STBT',
      item_category5: 'NSE CASH',
      item_category6: 'MCX',
      item_category7: 'NSE F&O',
      item_category8: 'Currency',
    },
  },
  {
    planName: 'BTST STBT',
    categories: {
      item_category: 'NSE F&O',
      item_category2: 'currency',
      item_category3: 'MCX',
    },
  },
  {
    planName: 'STOCK OF THE MONTH',
    categories: {
      item_category: 'NSE Cash',
    },
  },
  {
    planName: 'RAMBAAN PLAN',
    categories: {
      item_category: 'NSE Cash',
      item_category2: 'NSE F&O',
      item_category3: 'MCX',
    },
  },
  {
    planName: 'COMBO PLAN',
    categories: {
      item_category: 'NSE CASH',
      item_category2: 'MCX',
      item_category3: 'NSE F&O',
      item_category4: 'Currency',
    },
  },
  {
    planName: 'COMBO 1 PLAN',
    categories: {
      item_category: 'Brahmastra plan',
      item_category2: 'Stock of the Month',
      item_category3: 'BTST & STBT',
    },
  },
  {
    planName: 'COMBO 2 PLAN',
    categories: {
      item_category: 'Mahabahubali plan',
      item_category2: 'Stock of the Month',
      item_category3: 'BTST & STBT',
    },
  },
  {
    planName: 'MCX',
    categories: {
      item_category: 'MCX',
    },
  },
  {
    planName: 'NSE CASH',
    categories: {
      item_category: 'NSE CASH',
    },
  },
  {
    planName: 'NSE FandO',
    categories: {
      item_category: 'NSE F&O',
    },
  },
  {
    planName: 'CURRENCY',
    categories: {
      item_category: 'CURRENCY',
    },
  },
  {
    planName: 'NIFTY AND BANKNIFTY',
    categories: {
      item_category: 'NIFTY AND BANKNIFTY',
    },
  },
  {
    planName: 'CRUDE OIL',
    categories: {
      item_category: 'CRUDE OIL',
    },
  },
  {
    planName: 'NATURAL GAS',
    categories: {
      item_category: 'NATURAL GAS',
    },
  },
  {
    planName: 'GOLD',
    categories: {
      item_category: 'GOLD',
    },
  },
  {
    planName: 'SILVER',
    categories: {
      item_category: 'SILVER',
    },
  },
  {
    planName: 'COPPER',
    categories: {
      item_category: 'COPPER',
    },
  },
  {
    planName: 'ZINC',
    categories: {
      item_category: 'ZINC',
    },
  },
];

export default PlanCategoryList;
